export default {
  'register.steps.general.title': 'Empresa',
  'register.steps.general.description': 'Informações da sua empresa',
  'register.steps.contact.title': 'Contato',
  'register.steps.contact.description': 'Informações de contato',
  'register.steps.account.title': 'Acesso',
  'register.steps.account.description': 'Informações de usuário',
  'register.steps.confirm.title': 'Confirmação',
  'register.steps.confirm.description': 'Confirmar cadastro',
  'register.form.button.next': 'Próximo',
  'register.form.button.previous': 'Anterior',
  'register.form.button.register': 'Cadastrar',
  'register.form.general.name.label': 'Nome da empresa',
  'register.form.general.name.message': 'Informe o nome da empresa',
  'register.form.general.companyType.label': 'Tipo',
  'register.form.general.companyType.message': 'Escolha o tipo da empresa',
  'register.form.general.cnpj.label': 'CNPJ',
  'register.form.general.cnpj.message': 'Informe o CNPJ',
  'register.form.general.contactName.label': 'Nome do contato',
  'register.form.general.contactName.message': 'Informe o nome do contato',
  'register.form.general.phone.label': 'Telefone',
  'register.form.general.phone.message':
    'Informe um número de telefone para contato',
  'register.form.general.email.label': 'E-mail',
  'register.form.general.email.message': 'Informe um e-mail para contato',
  'register.form.general.email.message.valid':
    'Informe um endereço de e-mail válido',
  'register.form.contact.zip.label': 'CEP',
  'register.form.contact.zip.message': 'Informe o CEP',
  'register.form.contact.zip.message.valid': 'Informe um CEP válido',
  'register.form.contact.id.label': 'UF',
  'register.form.contact.id.message': 'Escolha uma UF',
  'register.form.contact.idCity.label': 'Cidade',
  'register.form.contact.idCity.message': 'Escolha uma cidade',
  'register.form.contact.district.label': 'Bairro',
  'register.form.contact.district.message': 'Informe um bairro',
  'register.form.contact.street.label': 'Logradouro',
  'register.form.contact.street.message': 'Informe um logradouro',
  'register.form.contact.number.label': 'Número',
  'register.form.contact.number.message': 'Informe um número',
  'register.form.contact.complement.label': 'Complemento',
  'register.form.account.login.label': 'Usuário',
  'register.form.account.login.message': 'Informe um usuário',
  'register.form.account.password.label': 'Senha',
  'register.form.account.password.message': 'Informe uma senha',
  'register.form.account.password.message.valid':
    'A senha deve ser formada por no mínimo 8 caracteres, e ter no mínimo uma letra maiúscula e um número',
  'register.form.account.passwordVerify.label': 'Confirmar senha',
  'register.form.account.passwordVerify.message': 'Informe novamente a senha',
  'register.form.account.passwordVerify.message.valid':
    'As duas senhas precisam ser iguais',
  'register.form.confirm.checkbox.label': 'Confirmo os dados informados',
  'register.form.confirm.checkbox.message': 'Por favor, marque a opção acima',
  'register.form.confirm.success.title': 'Conta criada com sucesso!',
  'register.form.confirm.success.subTitle':
    'Sua conta no Ultracar Web foi criada com sucesso! Um link de ativação foi enviado ao email cadastrado.',
  'register.form.confirm.success.button': 'Ir para o login',
  'register.form.notification.success': 'Conta criada com sucesso!',
  'register.form.notification.successDescription':
    'Sua conta foi criada com sucesso.',
  'register.form.notification.error': 'Erro ao criar a conta',
  'register.form.notification.errorDescription':
    'Ocorreu um erro ao tentar criar a conta. Por favor, verifique os campos e tente novamente.',
  'register.form.notification.error.duplicateEmail': 'E-mail Duplicado',
  'register.form.notification.error.duplicateEmail.description':
    'O e-mail "{email}" já existe.',
  'register.form.notification.error.duplicateUser': 'Usuário Duplicado',
  'register.form.notification.error.duplicateUser.description':
    'O usuário "{loginDuplicate}" já está sendo utilizado.',
};
